var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPersonalAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1122_50583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9762 43.8831V10.3751C81.9762 8.59769 81.2888 6.89311 80.065 5.63632C78.8413 4.37952 77.1816 3.67346 75.451 3.67346H10.1986C8.46798 3.67346 6.80826 4.37952 5.58454 5.63632C4.36082 6.89311 3.67334 8.59769 3.67334 10.3751V77.3911C3.67334 79.1684 4.36082 80.873 5.58454 82.1298C6.80826 83.3866 8.46798 84.0927 10.1986 84.0927H42.8248M75.5597 63.9879V86.3265M86.3264 75.0455H64.5756",
    stroke: "url(#paint0_linear_1122_50583)",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1635 42.2449C49.2499 42.2449 54.1839 37.3109 54.1839 31.2245C54.1839 25.1381 49.2499 20.2041 43.1635 20.2041C37.0771 20.2041 32.1431 25.1381 32.1431 31.2245C32.1431 37.3109 37.0771 42.2449 43.1635 42.2449Z",
    stroke: "#232C66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4488 61.5306C62.4488 51.3872 53.6074 43.1632 42.7039 43.1632C31.8003 43.1632 22.959 51.3872 22.959 61.5306",
    stroke: "#232C66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1122_50583",
    x1: 44.9999,
    y1: -22.5,
    x2: 44.9999,
    y2: 86.3265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B90D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_50583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonalAccount);
export default __webpack_public_path__ + "static/media/icon-personal-account.4949c9259a228c2e345e10200a04ccdc.svg";
export { ForwardRef as ReactComponent };